import { useState } from 'react';

import { UseFormikForm } from '../interfaces';
import { FormFieldError, UseState } from '../types';

export const useFormikForm: () => UseFormikForm = (): UseFormikForm => {
  const [isFormSubmittedState, setIsFormSubmittedState]: UseState<boolean> = useState<boolean>(false);

  const setFormSubmitted: () => void = (): void => setIsFormSubmittedState(true);

  const setFormNotSubmitted: () => void = (): void => setIsFormSubmittedState(false);

  const getFormikFieldError: (error: FormFieldError, onlyFirst?: boolean) => string | undefined = (
    error: FormFieldError, onlyFirst?: boolean
  ): string | undefined => {
    if (typeof error === 'string') {
      return error;
    } else if (typeof error === 'object' && !Array.isArray(error)) {
      const messages: string[] = Object.values(error);

      if (onlyFirst) {
        return messages.length
          ? messages[0]
          : '';
      } else {
        return messages.map((message: string): string => message).join(', ');
      }
    }

    return '';
  };

  return {
    setFormSubmitted,
    setFormNotSubmitted,
    getFormikFieldError,
    isFormSubmitted: isFormSubmittedState
  };
};
